import { render, staticRenderFns } from "./DnsTalk.vue?vue&type=template&id=6fbeb706&"
import script from "./DnsTalk.vue?vue&type=script&lang=js&"
export * from "./DnsTalk.vue?vue&type=script&lang=js&"
import style0 from "./DnsTalk.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DnsTalk.vue"
export default component.exports